import { combineReducers } from "redux";
import general from "./GeneralReducer/general";

const app = combineReducers({
	general,
});

export default app;
